import { LazyFallback } from 'components/shared/LazyFallback';
import { Suspense } from 'react';
import { useSyncOrderTypeWithUrl } from 'routes/secondary-market-batch/hooks/use-sync-order-type-with-url';
import { lazyWithRetry } from 'shared/lazy';

const SecondaryMarketBatchWorkspaceRouteLazy = lazyWithRetry(() => import('./workspace'));
export function SecondaryMarketBatchWorkspaceRoute() {
  useSyncOrderTypeWithUrl();
  return (
    <Suspense fallback={<LazyFallback className="flex-grow-1" />}>
      <SecondaryMarketBatchWorkspaceRouteLazy />
    </Suspense>
  );
}
